(function () {
  if (window.__separateDeliveryNoticeInit) return;
  window.__separateDeliveryNoticeInit = true;

  var STORAGE_KEY = 'separate_delivery_dismissed';

  function getDismissed() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      return JSON.parse(raw) || {};
    } catch (e) {
      return {};
    }
  }

  function saveDismissed(map) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  function applyDismissed(root) {
    var dismissed = getDismissed();
    var scope = root && root.querySelectorAll ? root : document;
    var notices = scope.querySelectorAll('[data-separate-delivery-notice]');
    for (var i = 0; i < notices.length; i++) {
      var pid = notices[i].getAttribute('data-product-id');
      if (pid && dismissed[pid]) {
        notices[i].hidden = true;
      }
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-separate-delivery-close]');
    if (!btn) return;
    var notice = btn.closest('[data-separate-delivery-notice]');
    if (!notice) return;
    var pid = notice.getAttribute('data-product-id');
    var dismissed = getDismissed();
    if (pid) {
      dismissed[pid] = 1;
      saveDismissed(dismissed);
      var matching = document.querySelectorAll(
        '[data-separate-delivery-notice][data-product-id="' + pid + '"]'
      );
      for (var i = 0; i < matching.length; i++) matching[i].hidden = true;
    } else {
      notice.hidden = true;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyDismissed(document);
    });
  } else {
    applyDismissed(document);
  }

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-separate-delivery-notice]')) {
            applyDismissed(node.parentNode || document);
          } else if (node.querySelector && node.querySelector('[data-separate-delivery-notice]')) {
            applyDismissed(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
